module.exports = __webpack_public_path__ + "static/media/heart_red_yl.5c281d2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/heart_red_yl.svg
// module id = 334
// module chunks = 0